import { z } from 'zod'

export const settlementApprovalResponseSchema = z.object({
  id: z.string().guid(),
  userId: z.string().guid(),
  userName: z.string().nullable(),
  accountId: z.string().guid().nullable(),
  status: z.string(),
  approvedAt: z.string().nullable(),
})

export type SettlementApprovalResponseDto = z.infer<typeof settlementApprovalResponseSchema>

export const settlementDebtResponseSchema = z.object({
  id: z.string().guid(),
  payerId: z.string().guid(),
  payerName: z.string().nullable(),
  receiverId: z.string().guid(),
  receiverName: z.string().nullable(),
  amount: z.number(),
  currency: z.string(),
})

export type SettlementDebtResponseDto = z.infer<typeof settlementDebtResponseSchema>

export const expenseFlagResponseSchema = z.object({
  id: z.string().guid(),
  expenseId: z.string().guid(),
  userId: z.string().guid(),
  userName: z.string().nullable(),
  comment: z.string().nullable(),
  createdAt: z.string(),
})

export type ExpenseFlagResponseDto = z.infer<typeof expenseFlagResponseSchema>

export const settlementRoundResponseSchema = z.object({
  id: z.string().guid(),
  groupId: z.string().guid(),
  initiatorId: z.string().guid(),
  initiatorName: z.string().nullable(),
  dateFrom: z.string(),
  dateTo: z.string(),
  status: z.string(),
  approvals: z.array(settlementApprovalResponseSchema),
  debts: z.array(settlementDebtResponseSchema),
  flags: z.array(expenseFlagResponseSchema),
  createdAt: z.string(),
  updatedAt: z.string(),
})

export type SettlementRoundResponseDto = z.infer<typeof settlementRoundResponseSchema>
